<template>
  <button
    class="
      h-14
      flex
      items-center
      justify-center
      rounded-2xl
      text-13
      tracking-wider
      font-bold
      uppercase
      cursor-pointer
      transition
      duration-300
      ease-out
    "
    :class="width + (disabled ? disabledColors + 'cursor-not-allowed' : colors)"
    :type="submit ? 'submit' : 'button'"
    :disabled="disabled && !softDisabled"
    :aria-disabled="disabled ? 'true' : null"
    @click="onClick"
  >
    <slot></slot>
  </button>
</template>

<script>
import { computed } from 'vue'
export default {
  emits: ['click'],
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    // When disabled, keep the button hoverable/focusable (native `disabled`
    // buttons don't receive hover events, which breaks CSS-only tooltips
    // explaining why the button is blocked) while still preventing clicks.
    softDisabled: {
      type: Boolean,
      default: false
    },
    submit: {
      type: Boolean,
      default: false
    },
    color: {
      type: String,
      default: 'orange'
    },
    desktopWidth: {
      type: String,
      default: 'w-64'
    },
    mobileWidth: {
      type: String,
      default: 'w-full'
    }
  },
  setup(props, { emit }) {
    const onClick = (event) => {
      if (props.disabled) {
        event.preventDefault()
        return
      }
      emit('click', event)
    }

    const colors = computed(() => {
      if (props.color === 'grey') {
        return 'bg-grey-1 text-white hover:bg-grey-2 '
      } else if (props.color === 'white') {
        return 'bg-white text-orange-1 hover:bg-grey-ghost '
      } else {
        return 'bg-orange-3 text-grey-1 hover:bg-orange-2 '
      }
    })

    const disabledColors = computed(() => {
      if (props.color === 'grey') {
        return 'bg-grey-6 text-grey-5 '
      } else if (props.color === 'white') {
        return 'bg-opacity-60 text-orange-1 text-opacity-30 '
      } else {
        return 'bg-orange-5 text-grey-6 '
      }
    })

    const width = computed(() => {
      return props.mobileWidth + ' lg:' + props.desktopWidth + ' '
    })

    return {
      colors,
      width,
      disabledColors,
      onClick
    }
  }
}
</script>

<style lang="scss" scoped></style>
